import { render, staticRenderFns } from "./studentManageMent.vue?vue&type=template&id=674f408a&scoped=true&"
import script from "./studentManageMent.vue?vue&type=script&lang=js&"
export * from "./studentManageMent.vue?vue&type=script&lang=js&"
import style0 from "./studentManageMent.vue?vue&type=style&index=0&id=674f408a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f408a",
  null
  
)

export default component.exports